// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hero.is-fullheight .hero-body {\n  align-items: inherit;\n  margin: 0 auto;\n}\n@media screen and (min-width: 1024px) {\n.hero.is-fullheight .hero-body {\n    padding-right: 14rem;\n}\n}", ""]);
// Exports
module.exports = exports;
